import { SeoScoreHero } from "./SeoScoreCard";

const AuditResults = ({ report }) => {
  return <SeoScoreHero report={report} />;
};

export default AuditResults;